import { useTranslation } from 'react-i18next';
import HeaderTemplate from 'components/Templates/Header/HeaderTemplate';
import { FC } from 'react';
import { Container, Box } from './CookieStatement.styled';
import CookieStatementContent from 'components/CookieStatement/CookieStatementContent';

const CookieStatement: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderTemplate sectionName={t('general.header.menu.cookie-statement')} />
      <Container>
        <Box my={5}>
            <CookieStatementContent />
        </Box>
      </Container>
    </>
  );
};

export default CookieStatement;
